export const GOOGLE_ADS_SCOPES = "https://www.googleapis.com/auth/adwords";

/** YouTube / Google social posting scopes (no Ads requirement). */
export const GOOGLE_SOCIAL_SCOPES =
  "https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube.readonly";

export const YES_NO_RADIO_BTN = [
  {
    name: "No",
  },
  {
    name: "Yes",
  },
];
